import React from 'react'
import cn from 'classnames'
import { UseFormMethods, Controller } from 'react-hook-form'
import {
    LearningLanguage,
    learningLanguages,
    useSetLanguage,
} from 'utils/learningLanguage'

type Props = {
    title?: string
    className?: string
    // eslint-disable-next-line
    form: UseFormMethods<any>
}

export default function LearningLanguageSelector({
    form,
    title,
    className,
}: Props) {
    const setLanguage = useSetLanguage()
    return (
        <div className={className}>
            {title && <div className="text-lg ml-1 mb-1">{title}</div>}
            <div className="flex">
                <Controller
                    control={form.control}
                    name="learningLanguage"
                    render={({ value, onChange }) => {
                        const onClick = (language: LearningLanguage) => {
                            setLanguage(language)
                            onChange(language)
                        }
                        return (
                            <>
                                {learningLanguages.map((language, i) => (
                                    <div
                                        key={i}
                                        className={cn(
                                            'h-10 cursor-pointer flex-center border-gray-c5 w-1/2',
                                            value === language && 'bg-gray-dc',
                                            i === 0 && 'border rounded-l',
                                            i !== 0 &&
                                                i !==
                                                    learningLanguages.length -
                                                        1 &&
                                                'border-t border-b',
                                            i ===
                                                learningLanguages.length - 1 &&
                                                'border rounded-r',
                                        )}
                                        onClick={() => onClick(language)}
                                    >
                                        {language}
                                    </div>
                                ))}
                            </>
                        )
                    }}
                />
            </div>
        </div>
    )
}
